import React from "react";
import activitesJson from "../../../Forms/activities.json";

const SelectedActivities = ({ activites = [], onRemoveActivite }) => {
  if (!activites || activites.length === 0) return null;

  return (
    <div className="d-flex flex-wrap flex-column mt-4" style={{ gap: 8 }}>
      <div className="text-primary font-weight-bold mb-2">
        Activités sélectionnées{" "}
        <div className="badge bg-primary text-white">{activites.length}</div>
      </div>
      <div className="d-flex flex-wrap" style={{ gap: 8 }}>
        {activites.map((activite, index) => {
          const activiteRef = activitesJson.find((a) => a.id == activite);
          if (!activiteRef) return null;
          return (
            <div>
              <button
                key={`activite-${activiteRef.id}-${index}`}
                className="btn btn-default bg-primary text-white btn-small shadow-small d-flex align-items-center px-3 py-2"
                type="button"
                style={{ fontSize: 14 }}
                onClick={(e) => {
                  e.stopPropagation(); // Empêche le clic du bouton parent
                  onRemoveActivite(activiteRef.id);
                }}
              >
                <div className="text-left">{activiteRef.name}</div>
                <i
                  className="fa fa-times ml-2"
                  style={{ cursor: "pointer", lineHeight: "22px" }}
                />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedActivities;
